export const accountDebtColumns = [
  {
    key: 'concept',
    name: 'Concepto',
    width: 0.6
  },
  {
    key: 'amount',
    name: 'Importe',
    width: 0.4
  }
];

export const historyColumns = [
  {
    key: 'date',
    name: 'Fecha',
    width: 0.6
  },
  {
    key: 'status',
    name: 'Estado',
    width: 0.4
  }
];
